import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AddPlotsForm.css';

const AddPlotsForm = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [svgFile, setSvgFile] = useState(null);
  const [price, setPrice] = useState('');
  const [size, setSize] = useState('');
  const navigate = useNavigate();

    // Modal states
  const [modal, setModal] = useState({ show: false, type: '', message: '' });

  useEffect(() => {
    // Fetch all projects
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/projects`);
        setProjects(response.data.projects || []);
      } catch (error) {
        showModal('error', 'Failed to fetch projects');
      }
    };

    fetchProjects();
  }, []);

  const showModal = (type, message) => {
    setModal({ show: true, type, message });
    setTimeout(() => setModal({ show: false, type: '', message: '' }), 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProject || !svgFile || !price || !size) {
      return showModal('error', 'Please fill in all fields.');
    }

    const formData = new FormData();
    formData.append('svg', svgFile);
    formData.append('defaultPrice', price);
    formData.append('defaultSize', size);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload/${selectedProject}`,
        formData
      );

        if (response.data.success) {
            showModal('success', 'Upload successful and plots created.');
            setSelectedProject('');
            setSvgFile(null);
            setPrice('');
            setSize('');
            navigate('/dashboard');
        } else {
            showModal('error', response.data.message || 'Upload failed.');
        }
    } catch (error) {
      showModal('error', error.response?.data?.message || 'Server error');
    }
  };

  return (
    <div className="add-plots-form-container">
      <h2> Add Plots</h2>
      <form onSubmit={handleSubmit} className="add-plots-form">
        <label>Choose Project:</label>
        <select
          value={selectedProject}
          onChange={(e) => setSelectedProject(e.target.value)}
        >
          <option value="">-- Select Project --</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </select>

        <label>Upload SVG File:</label>
        <input
          type="file"
          accept=".svg"
          onChange={(e) => setSvgFile(e.target.files[0])}
        />

        <label>Default Price:</label>
        <input
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        <label>Default Size:</label>
        <input
          type="text"
          value={size}
          onChange={(e) => setSize(e.target.value)}
        />

        <button type="submit">Upload & Create Plots</button>
      </form>
      {/* Modal for success/error messages */}
      {modal.show && (
        <div className={`modal ${modal.type}`}>
            <div className="modal-content">
                <p>{modal.message}</p>
            </div>
        </div>
      )}
    </div>
  );
};

export default AddPlotsForm;
